module.exports = __webpack_public_path__ + "img/b6-5.80f801b.png";